import React from 'react';

function icon() {
	const icon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width="24"
			height="24"
		>
			<rect x="2" y="2" width="20" height="20" rx="3" fill="#008080" />
			<rect x="4" y="5" width="5" height="14" rx="1" fill="white" />
			<rect x="9.5" y="5" width="5" height="14" rx="1" fill="white" />
			<rect x="15" y="5" width="5" height="14" rx="1" fill="white" />
		</svg>
	);
	return icon;
}

export default icon;
